import { CloudProduct } from '@/types/enums';

function getCloudProduct(product: CloudProduct | string): string {
  if (product === CloudProduct.Censor) return '文字违规检测';
  if (product === CloudProduct.Spell) return '错别字检查';
  if (product === CloudProduct.Vod) return '云视频';
  if (product === CloudProduct.Sms) return '短信';
  if (product === CloudProduct.Mail) return '邮件';

  return '';
}

export default getCloudProduct;
